module.exports = __webpack_public_path__ + "img/sparkasse.b565c5e9.svg";